export default "__VITE_ASSET__VhjdJef0__"